import React from 'react';
import _classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import FallbackIcon from './images/fallbackIcon.svg';

const useStyles = makeStyles(theme => ({
  image: {
    maxWidth: '100%',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  fallback: {
    position: 'relative',
    background: '#EEF9FF',
    minHeight: props => (props.isCard ? 123 : 270),
  },
  messageContainer: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: 16,
  },
  message: {
    fontFamily: 'Mada',
    color: '#757575',
    fontSize: 14,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '88%',
    [theme.breakpoints.down('sm')]: {
      maxWidth: props => (props.isCard ? '50%' : '65%'),
    },
  },
}));

export const ImageWithFallback = ({
  imageError,
  setImageError,
  src,
  title,
  isCard,
}) => {
  const classes = useStyles(isCard);

  const handleError = () => {
    setImageError(true);
  };

  return (
    <>
      {!src || imageError ? (
        <div className={_classNames(classes.image, classes.fallback)}>
          <div className={classes.messageContainer}>
            <img src={FallbackIcon} alt="Fallback Icon" />
            <b className={classes.message}>{title}</b>
          </div>
        </div>
      ) : (
        <img
          className={classes.image}
          src={src}
          alt={title}
          onErrorCapture={handleError}
        />
      )}
    </>
  );
};

export default ImageWithFallback;
